var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "GmapMap",
        {
          staticClass: "ratio ratio-16x9",
          attrs: {
            center: { lat: 38.470256, lng: -98.795222 },
            zoom: 4,
            options: {
              streetViewControl: false,
              mapTypeControl: false
            }
          },
          on: {
            click: function($event) {
              _vm.infoWinOpen = false
            }
          }
        },
        [
          _c("gmap-info-window", {
            attrs: {
              options: _vm.infoOptions,
              position: _vm.infoWindowPos,
              opened: _vm.infoWinOpen
            },
            on: {
              closeclick: function($event) {
                _vm.infoWinOpen = false
              }
            }
          }),
          _vm._v(" "),
          _vm._l(_vm.markers, function(m, i) {
            return _c("GmapMarker", {
              key: i,
              attrs: { position: m.position, draggable: true, clickable: true },
              on: {
                click: function($event) {
                  return _vm.toggleInfoWindow(m, i)
                }
              }
            })
          })
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }